import * as React from 'react';
import TextField from '@mui/material/TextField';
import { TextBoxType } from '../../../types/common.types';
import { makeStyles } from '@mui/styles';
import { colors, theme } from '../../../theme';

export const testid = 'search';

const color = colors();
const themes = theme().typography;
export const TextBox = ({
	id,
	label,
	labelText,
	value,
	isMultiline,
	lines,
	isFixedHeight = true,
	variant,
	width = 120,
	disabled,
	noBorder,
	onChangeCallback,
	placeHolder,
}: TextBoxType) => {
	const classes = useStyles();

	return (
		<div>
			<div className={classes.label}>{labelText}</div>
			<TextField
				id={id.toString()}
				data-testid={testid}
				label={label}
				variant={variant || 'outlined'}
				size="small"
				placeholder={placeHolder}
				sx={{
					m: 1,
					width: { width },
					'& .MuiOutlinedInput-root': {
						'& fieldset': {
							border: noBorder ? 'none' : undefined,
						},
						'&:hover fieldset': {
							border: noBorder
								? 'none'
								: disabled
								? `1px solid ${color.neutral[5]}`
								: `1px solid ${color.shades.blue[50]}`,
						},
						'&.Mui-focused fieldset': {
							border: noBorder ? 'none' : undefined,
						},
					},
				}}
				value={value}
				className={classes.textbox}
				multiline={isMultiline}
				{...(isFixedHeight ? { rows: lines || 4 } : { maxRows: 10, minRows: lines || 2 })}
				disabled={disabled}
				onChange={(e) => onChangeCallback && onChangeCallback(e.target.value)}
			/>
		</div>
	);
};

const useStyles = makeStyles(() => ({
	textbox: {
		'& .MuiInputLabel-formControl': {
			...themes.bodyRegular,
			color: color.neutral[5],
		},
		'& .Mui-focused.MuiInputLabel-formControl': {
			color: color.signal.info,
		},
		'& .MuiInputBase-input': {
			...themes.bodyRegular,
			color: color.neutral[8],
		},
		'& .MuiOutlinedInput-notchedOutline': {
			borderColor: color.neutral[5],
		},
		'& .Mui-focused .MuiOutlinedInput-notchedOutline': {
			border: `2px solid ${color.signal.info} !important`,
		},
	},
	label: {
		...themes.metaText,
		padding: '0px 8px',
		marginBottom: '-5px',
	},
}));
